import { FC, ReactNode, CSSProperties } from 'react';
import classnames from 'classnames';
import { ProTooltip } from '../antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { TooltipPropsWithTitle } from 'antd/lib/tooltip';
import styles from './style.module.less';

export interface HelpTooltipProps extends TooltipPropsWithTitle {
  /** 图标 */
  icon?: ReactNode;
  /** 图标大小 */
  iconSize?: number;
  /** 图标颜色 */
  iconColor?: string;
  /** 类名 */
  className?: string;
}
/** 提示 */
export const HelpTooltip: FC<HelpTooltipProps> = props => {
  const { icon, children, iconSize, iconColor, className, ...resProps } = props;
  const styleObj: CSSProperties = {};
  if (iconSize) styleObj.fontSize = iconSize;
  if (iconColor) styleObj.color = iconColor;
  const classes = classnames('flex-center-start', 'yb-inline-block', className);
  return (
    <div className={classes}>
      {children}
      <ProTooltip {...resProps}>
        <span className={styles['help-tooltip']} style={styleObj}>
          {icon}
        </span>
      </ProTooltip>
    </div>
  );
};
HelpTooltip.defaultProps = {
  icon: <QuestionCircleOutlined />,
  placement: 'top',
  iconSize: 14,
  iconColor: 'rgba(0, 0, 0, 0.8)',
};

export default HelpTooltip;
